const BREAKPOINT = {
    SCREEN_PHONE: 600,
    SCREEN_TABLET: 768,
    SCREEN_LAPTOP: 992,
    SCREEN_DESKTOP: 1200
};

const currentBreakpoint = () => {
    if (window.innerWidth < BREAKPOINT.SCREEN_PHONE) {
      return BREAKPOINT.SCREEN_PHONE;
    } else if (window.innerWidth < BREAKPOINT.SCREEN_TABLET) {
      return BREAKPOINT.SCREEN_TABLET;
    } else if (window.innerWidth < BREAKPOINT.SCREEN_LAPTOP) {
      return BREAKPOINT.SCREEN_LAPTOP;
    } else {
      return BREAKPOINT.SCREEN_DESKTOP;
    }
  }

export {
    BREAKPOINT, currentBreakpoint
};
